export default "__VITE_ASSET__YMeCuOnw__"